"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../Types");
var react_router_dom_1 = require("react-router-dom");
var components_1 = require("@athena-portal/components");
var SupportPortalTemplates_1 = require("../../SupportPortalTemplates");
var Page_1 = require("../Page");
var Tree_1 = require("../../components/Tree");
var DocumentsTree = /** @class */ (function (_super) {
    __extends(DocumentsTree, _super);
    function DocumentsTree(props) {
        var _this = _super.call(this, props) || this;
        _this.supportPortalTemplates = new SupportPortalTemplates_1.SupportPortalTemplates;
        _this.downloadDocument = function (doc) { return function (event) {
            _this.supportPortalService.downloadDocument(doc.id).subscribe(function (documentContent) {
                if (documentContent) {
                    var link = document.createElement("a");
                    var blob = new Blob([documentContent]);
                    var blobUrl = URL.createObjectURL(blob);
                    document.body.appendChild(link);
                    link.download = doc.name;
                    link.href = blobUrl;
                    link.click();
                    document.body.removeChild(link);
                }
            });
        }; };
        _this.state = {};
        return _this;
    }
    DocumentsTree.prototype.render = function () {
        if (this.props.documents && this.props.documents.length > 0) {
            var documentsTree = [];
            for (var _i = 0, _a = this.props.documents; _i < _a.length; _i++) {
                var document_1 = _a[_i];
                documentsTree.push((0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("i", { className: "far fa-file-alt" }), " ", this.getDocumentName(document_1), (0, jsx_runtime_1.jsx)("br", {})] }) }, document_1.id));
            }
            return ((0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: "Documents [".concat(this.props.documents.length, "]"), children: documentsTree }));
        }
        return (0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: "Documents [0]" });
    };
    DocumentsTree.prototype.getDocumentName = function (document) {
        if (this.supportPortalTemplates.userHasRole(["Administrator", "Claims_Handler", "Fraud", "CSR_Lead", "CSR", "Read_Only"])) {
            return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "#", onClick: this.downloadDocument(document), children: "".concat(document.name) }), " [".concat(SupportPortalTemplates_1.SupportPortalTemplates.convertDateToUkTimeZoneDate(document.date), "]")] });
        }
        return document.name;
    };
    DocumentsTree.contextType = Page_1.PageContext;
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], DocumentsTree.prototype, "supportPortalService", void 0);
    DocumentsTree = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], DocumentsTree);
    return DocumentsTree;
}(React.Component));
exports.default = DocumentsTree;
//# sourceMappingURL=DocumentsTree.js.map